import createSalaryStructure from './mutations/createSalaryStructure';
import updateSalaryStructure from './mutations/updateSalaryStructure';
import getSalaryStructure from './queries/getSalaryStructure';
import listSalaryStructures from './queries/listSalaryStructures';

const salaryStructures = {
  queries: {
    listSalaryStructures,
    getSalaryStructure,
  },
  mutations: {
    createSalaryStructure,
    updateSalaryStructure,
  },
};

export default salaryStructures;
